import { Row } from "antd";
import DOMPurify from "dompurify";
import AppTitle from "../app-title/app-title";
import Feedback from "../feedback/feedback";

const answers = [
  {
    answer: "Что входит в стоимость авто?",
    question:
      "<p>Вы приобретаете у нас технику со всем пакетом документов!<br />В стоимость входит, цена на автомобиль, все авто проходят таможенное оформление, уплачены пошлины, установлены системы ЭРА-Глонасс<br />и получены ЭПТС со статусом действующий</p>",
  },
  {
    answer: "Можно у вас привезти авто под заказ?",
    question: `<p>Да, позвоните по телефону <a href='tel:+7 8482 43 55 50'>+7 8482 43 55 50</a> и наш менеджер подберёт<br />технику по вашим характеристикам и ответит на все вопросы по заказу</p>`,
  },
  {
    answer: "Могу ли я купить в лизинг?",
    question: `<p>Да, мы работаем с лизинговыми компаниями, преимущественно с Альфа лизингом.<br />Для уточнения работы с вашей лизинговой компанией, позвоните по телефону <a href='tel:8 8482 43 55 50'>8 8482 43 55 50</a></p>`,
  },
  {
    answer: "Могу я у вас купить запчасти?",
    question: `<p>У нас есть все запчасти на DAF, для уточнения наличия или по срокам поставки, по телефону <a href='tel:8 8482 611 550'>8 8482 611 550</a></p>`,
  },
  {
    answer: "Как записаться на сервис?",
    question: `<p>Для этого достаточно позвонить по телефону:<br />Тольятти (с. Зелёновка) <a href='tel:+7 (8482) 611 550'>+7 (8482) 611 550</a><br />Казань <a href='tel:+7 (843) 239-05-50'>+7 (843) 239-05-50</a><br />Набережные челны <a href='tel:+7 (8552) 784-550'>+7 (8552) 784-550</a><br />Екатеринбург <a href='tel:+7 (8482) 622-550'>+7 (8482) 622-550</a><br />Уфа <a href='tel:+7 (347) 262-77-55'>+7 (347) 262-77-55</a></p>`,
  },
];

function MainPageFaqSection() {
  return (
    <>
      <AppTitle text={"Отвечаем на вопросы"} />
      <Row
        style={{ backgroundColor: "#fff", marginTop: "20px", display: "block" }}
      >
        <div className="accordions content">
          {answers.map((item) => (
            <div key={item.answer}>
              <button
                onClick={(e) => questions(e.target)}
                className="accordion"
              >
                {item.answer}
              </button>
              <div className="panel">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(item.question),
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </Row>
      <Row>
        <Feedback
          text={
            <>
              Напишите свои контакты
              <br /> и мы
              <span style={{ color: "#F67828" }}> вам перезвоним </span>
            </>
          }
          isMobileResponsive={true}
        />
      </Row>
    </>
  );
}

function questions(item) {
  item.classList.toggle("active");
  const panel = item.nextElementSibling;
  panel.style.maxHeight
    ? (panel.style.maxHeight = null)
    : (panel.style.maxHeight = panel.scrollHeight + "px");
}

export default MainPageFaqSection;
